import { useState, useEffect } from "react";

export const useUserMedia = (constraints: MediaStreamConstraints) => {
  const [stream, setStream] = useState<MediaStream>();
  const [error, setError] = useState(null);
  useEffect(() => {

    //if (stream) return;
    let didCancel = false;

    const getUserMedia = async () => {
      if (!didCancel && !stream) {
        try {
          var userMedia = await navigator.mediaDevices.getUserMedia({
            ...constraints,
          });
          setStream(userMedia);
        } catch (e) {
          setError(e);
        }
      }
    };
    const cancel = () => {
      didCancel = true;

      if (!stream) return;

      stream.getVideoTracks().forEach(track => track.stop());

      stream.getAudioTracks().forEach(track => track.stop());
    };

    getUserMedia();

    return cancel;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [constraints]);

  return { stream, error };
};
